import React from 'react'
import { Grid, GridCell, Text, View } from 'oio-react'
import { Link } from 'react-router-dom'
import GlobalViewport from 'src/apps/Global/components/Viewport'
import { useInitiativeList, useOrganization } from 'src/graphql/hooks'

const HomeApp = () => {
   const { organization } = useOrganization()
   const newsInitiativeTypes = organization.initiativeTypes.filter(t => (
      t.class === 'post' && t.enabled
   )).map(t => t.id)

   const otherInitiativeTypes = organization.initiativeTypes.filter(t => (
      t.class !== 'post' && t.enabled
   )).map(t => t.id)

   const { initiativeList: newsInitiativeList } = useInitiativeList({
      limit: 3,
      sortBy: 'dateLastUpdated',
      typeIds: newsInitiativeTypes
   })

   // Non-news initiatives
   const { initiativeList } = useInitiativeList({
      limit: 5,
      sortBy: 'dateLastUpdated',
      typeIds: otherInitiativeTypes
   })

   return (
      <GlobalViewport>
         <View
            backgroundColor="#fafafa"
            margin="10px 0px"
            display="flex"
            justifyContent="center"
            width="100%">
            <View>
               <View>
                  <View
                     position="relative"
                     width="100%"
                     height="100vh"
                     backgroundColor="#181818">
                     <View
                        position="absolute"
                        top="0px"
                        right="0px"
                        width="100%"
                        bottom="0vh"
                        backgroundSize="cover"
                        backgroundImage={
                           organization.coverMedia &&
                            `url(${organization.coverMedia.file.thumbnailUrlW1600})`}
                        backgroundPosition="center center"
                     />
                     <View
                        display="none"
                        textAlign="center"
                        alignItems="center"
                        padding="40px 40px"
                        position="absolute"
                        top="0px"
                        right="0px"
                        width="35%"
                        bottom="0px">
                        <View paddingTop="20px">
                           <Text
                              weight="medium"
                              size="9"
                              lineHeight="120%"
                              transform="uppercase"
                              color="#fff">
                              Black Collection Backpack
                           </Text>
                           <View
                              display="inline-block"
                              width="40px"
                              height="2px"
                              backgroundColor="#ddd"
                           />
                           <View width="100%" height="10px" />
                           <View width="100%">
                              <Text
                                 fontFamily="Baskerville"
                                 lineHeight="130%"
                                 size="6"
                                 color="#aaa">
                                 Introducing our new everyday
                                 <br />
                                 bag for work and play.
                              </Text>
                           </View>
                        </View>
                     </View>
                  </View>
               </View>
               <View padding="50px">
                  <Grid columns="12" spacing="15px[a-d] 20px[e-f]">
                     <GridCell colspan="4">
                        <View
                           padding="0px 0px 10px 0px"
                           style={{ overflow: 'hidden' }}>
                           <View width="100%">
                              <View
                                 width="100%"
                                 borderBottom="1px solid #ddd"
                                 padding="0px 0px 15px 0px">
                                 <Text size="0.9" weight="bold" transform="uppercase" color="#aaa">
                                    Latest News
                                 </Text>
                              </View>
                              <View width="100%" height="30px" />
                              <View width="100%" paddingRight="20%">
                                 <Text
                                    letterSpacing="-1px"
                                    weight="medium"
                                    size="7"
                                    lineHeight="120%"
                                    transform="uppercase"
                                    fontFamily="Optima"
                                    color="#000">
                                    {organization.tagline}
                                 </Text>
                              </View>
                              <View width="100%" height="10px" />
                              <View
                                 display="inline-block"
                                 width="40px"
                                 height="5px"
                                 backgroundColor="#ddd"
                              />
                              <View width="100%" height="30px" />
                              <View width="100%">
                                 <Text
                                    lineHeight="130%"
                                    size="3"
                                    color="#777">
                                    <div
                                       dangerouslySetInnerHTML={{
                                          __html: organization.description
                                       }}
                                    />
                                 </Text>
                              </View>
                              <View width="100%" height="20px" />
                              <Text
                                 weight="bold"
                                 size="1"
                                 transform="uppercase"
                                 color="#000">
                                 September 11, 2020
                              </Text>
                           </View>
                        </View>
                     </GridCell>
                     <GridCell colspan="4">
                        <View
                           paddingLeft="20px"
                           paddingRight="20px"
                           borderRight="1px solid #ddd"
                           borderLeft="1px solid #ddd">
                           <View
                              width="100%"
                              padding="0px 0px 15px 0px">
                              <Text size="0.9" weight="bold" transform="uppercase" color="#aaa">
                                 Latest News
                              </Text>
                           </View>
                           {newsInitiativeList.items.length > 0 && (
                              <View
                                 width="100%"
                                 marginBottom="30px">
                                 <Grid columns="1" spacing="0px">
                                    {newsInitiativeList.items.map(initiative => (
                                       <GridCell key={initiative.id}>
                                          <Link to={`/initiatives/${initiative.slug}`}>
                                             <View
                                                width="100%"
                                                display="inline-flex"
                                                padding="20px 0px"
                                                borderTop="1px solid #ddd">
                                                <View flex="1 1 auto">
                                                   <View marginBottom="2px">
                                                      <Text
                                                         transform="uppercase"
                                                         fontFamily="Optima"
                                                         weight="medium"
                                                         size="2"
                                                         color="#000">
                                                         {initiative.name}
                                                      </Text>
                                                   </View>
                                                   <View marginBottom="5px">
                                                      <Text size="1.5" color="#888">
                                                         <div
                                                            style={{
                                                               maxHeight: '70px',
                                                               overflow: 'hidden',
                                                               textOverflow: 'ellipsis'
                                                            }}
                                                            dangerouslySetInnerHTML={{
                                                               __html: initiative.body.summary
                                                            }}
                                                         />
                                                      </Text>
                                                   </View>
                                                   <Text
                                                      size="0.9"
                                                      color="#333"
                                                      transform="uppercase">
                                                      {initiative.dateLastUpdated}
                                                   </Text>
                                                </View>
                                                <View
                                                   display="none"
                                                   flex="0 0 auto"
                                                   width="60px"
                                                   height="60px"
                                                   backgroundColor="#eee"
                                                   backgroundImage={initiative.coverMedia && `url(${initiative.coverMedia.file.thumbnailUrlW480})`}
                                                   backgroundSize="cover"
                                                   backgroundPosition="center center"
                                                   backgroundRepeat="no-repeat"
                                                   marginLeft="20px"
                                                />
                                             </View>
                                          </Link>
                                       </GridCell>
                                    ))}
                                 </Grid>
                              </View>
                           )}
                        </View>
                     </GridCell>
                     <GridCell colspan="4">
                        <View>
                           <View
                              borderTop22="1px solid #ddd"
                              width="100%"
                              padding="0px 0px 15px 0px">
                              <Text size="0.9" weight="bold" transform="uppercase" color="#aaa">
                                 Latest Activity
                              </Text>
                           </View>
                           {initiativeList.items.map(initiative => (
                              <Link key={initiative.id} to={`/initiatives/${initiative.slug}`}>
                                 <View
                                    display="flex"
                                    padding="15px 0px"
                                    borderTop="1px solid #ddd">
                                    <View flex="1 1 auto">
                                       <Text size="2" weight="medium" color="#000">
                                          {initiative.name}
                                       </Text>
                                       <Text size="1.5" color="#aaa">
                                          {`Last updated ${initiative.dateLastUpdated}`}
                                       </Text>
                                    </View>
                                    {/* <View
                                       flex="0 0 auto"
                                       width="35px"
                                       height="35px"
                                       backgroundColor="#eee"
                                       marginLeft="20px"
                                    /> */}
                                 </View>
                              </Link>
                           ))}
                        </View>
                     </GridCell>
                  </Grid>
               </View>
            </View>
         </View>
      </GlobalViewport>
   )
}

export default HomeApp
